import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("imayo_lang") || "es";
    } catch (e) {
      return "es";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("imayo_lang", lang);
      document.documentElement.lang = lang;
    } catch (e) {
      // localStorage may be unavailable
    }
  }, [lang]);

  const t = translations[lang] || translations.es;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
